import React, { useState, useRef, useContext } from "react";
import { NavLink } from "react-router-dom";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { UserContext } from "../../../context/UserContext";

const Sidebar = () => {
  const { isEligible } = useContext(UserContext);
  const [expanded, setExpanded] = useState(false);
  const sidebarRef = useRef(null);
  const sidebarTextRefs = useRef([]);

  gsap.registerPlugin(useGSAP);

  useGSAP(() => {
    const sidebar = sidebarRef.current;

    const handleMouseEnter = () => {
      gsap.to(sidebar, {
        width: "18rem", // Expanded width
        duration: 0.1, // Animation duration
        ease: "power2.inOut", // Smooth easing function
        onStart: () => {
          sidebarTextRefs.current.forEach((text) => {
            if (text) {
              gsap.to(text, {
                opacity: 1,
                visibility: "visible",
                duration: 0.4,
                delay: 0.1, // Slight delay for smoother transition
              });
            }
          });
        },
        onComplete: () => {
          setExpanded(true);
        },
      });
    };

    const handleMouseLeave = () => {
      gsap.to(sidebar, {
        width: "6rem", // Collapsed width
        duration: 0.1, // Animation duration
        ease: "power2.inOut", // Smooth easing function
        onStart: () => {
          sidebarTextRefs.current.forEach((text) => {
            if (text) {
              gsap.to(text, {
                opacity: 0,
                visibility: "hidden",
                //duration: 0.2,
              });
            }
          });
        },
        onComplete: () => {
          setExpanded(false);
        },
      });
    };

    sidebar.addEventListener("mouseenter", handleMouseEnter);
    sidebar.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      sidebar.removeEventListener("mouseenter", handleMouseEnter);
      sidebar.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <div
      ref={sidebarRef}
      className="fixed top-16 left-0 h-full bg-white shadow-lg z-20 flex flex-col items-start w-24 transition-all duration-100"
    >
      <ul className="space-y-6 w-full overflow-y-auto max-h-[calc(100vh-5rem)] pt-8 pb-8">
        {/* Dashboard Link */}
        <li>
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `group flex items-center w-full px-8 py-3 transition-all ${
                isActive
                  ? "bg-blue-100 text-blue-800"
                  : "hover:bg-blue-100 text-gray-700"
              }`
            }
          >
            <i className="fas fa-home text-2xl w-10 h-10 flex justify-center items-center"></i>
            <span
              ref={(el) => (sidebarTextRefs.current[0] = el)}
              className="ml-1 text-sm font-medium opacity-0 invisible"
            >
              Dashboard
            </span>
          </NavLink>
        </li>

        {/* Free Consultation Link */}
        <li>
          <NavLink
            to="/consultations"
            className={({ isActive }) =>
              `group flex items-center w-full px-8 py-3 transition-all ${
                isActive
                  ? "bg-blue-100 text-blue-800"
                  : "hover:bg-blue-100 text-gray-700"
              }`
            }
          >
            <i className="fas fa-comments text-2xl w-10 h-10 flex justify-center items-center"></i>
            <span
              ref={(el) => (sidebarTextRefs.current[2] = el)}
              className="ml-1 text-sm font-medium opacity-0 invisible"
            >
              Book Consultation
            </span>
          </NavLink>
        </li>

        {/* Apply for Application Link */}
        <li>
          <NavLink
            to="/application"
            // className={({ isActive }) =>
            //   `group flex items-center w-full px-8 py-3 transition-all ${
            //     isActive
            //       ? 'bg-blue-100 text-blue-800'
            //       : (isEligible === "true") || (isEligible === true)
            //       ? 'hover:bg-blue-100 text-gray-700'
            //       : 'text-gray-300 cursor-not-allowed' // Disabled styles
            //   }`
            className={({ isActive }) =>
              `group flex items-center w-full px-8 py-3 transition-all ${
                isActive
                  ? "bg-blue-100 text-blue-800"
                  : "hover:bg-blue-100 text-gray-700"
              }`
            }
            // onClick={(e) => {
            //   if (isEligible === "false") {
            //     e.preventDefault(); // Prevent navigation if not eligible
            //   }
            // }}
          >
            <i className="fas fa-file-alt text-2xl w-10 h-10 flex justify-center items-center"></i>
            <span
              ref={(el) => (sidebarTextRefs.current[1] = el)}
              className="ml-1 text-sm font-medium opacity-0 invisible"
            >
              Apply for Application
            </span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
